export const DATA_TYPE = {
  DIET: "diet",
  WATER: "water",
  PROFILE: "profile",
  CUSTOM: "custom",
}

export const setData = (name, data) => {
  localStorage.setItem(name, JSON.stringify(data))
}

export const getData = (name) => {
  return JSON.parse(localStorage.getItem(name) || "{}")
}

export const getDataByDate = (name, date) => {
  return (getData(name)?.value || []).filter(
    ({ createdAt }) => createdAt === date
  )
}

export const removeDataById = (name, id) => {
  const data = { value: getData(name)?.value || [] }
  data.value = data.value.filter((item) => item.id !== id)

  setData(name, data)
}

const getCurrentData = (name) => {
  const data = { value: getData(name)?.value || [] }
  // TODO get current day

  const value = 0

  // TODO add filter and counter

  return value
}

export const getCurrentKCal = () => {
  return getCurrentKCal(DATA_TYPE.DIET)
}

export const getCurrentWater = () => {
  return getCurrentKCal(DATA_TYPE.WATER)
}
